import * as React from "react";
const SvgAddItem = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 21V13H3V11H11V3H13V11H21V13H13V21H11Z" }));
export default SvgAddItem;
